import React from 'react';

import { Button, Checkbox, } from 'antd';
import { ListView, Modal, SearchBar, Toast } from 'antd-mobile';

import styles from './selectformdata.module.css'
import { _getLinkedDataForm } from "../../server";
import "../../assets/fonts/iconfont.css"

function closest(el, selector) {
    const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
    while (el) {
        if (matchesSelector.call(el, selector)) {
            return el;
        }
        el = el.parentElement;
    }
    return null;
}

let pageIndex = 0;
let pageSize = 10;

class SelectFormData extends React.Component {

    maxLength = 30;

    constructor(props) {
        super(props)
        this.sid = this.props.sid;

        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 != row2
        });

        this.state = {
            dataSource,
            isLoading: true,
            modalVisible: false,
            isShowSearchPop: false,
            height: document.documentElement.clientHeight,
            definitionId: "",
            fieldId: "",
            searchKey: "",
            formDataList: [],
            selectedFormData: [],
            formFieldList: [],
        };
    }

    componentDidMount() {
        this.props.triggerRef(this);
    }

    componentWillUnmount() {

    }

    onEndReached = (event) => {
        if (this.state.searchKey) {
            return;
        }
        if (this.state.isLoading) {
            return;
        }
        this.setState({ isLoading: true });
        ++pageIndex;
        this.getLinkedDataForm(this.state.definitionId, this.state.fieldId);
    }

    onWrapTouchStart = (e) => {
        // fix touch to scroll background page on iOS
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return;
        }
        const pNode = closest(e.target, '.am-modal-content');
        if (!pNode) {
            e.preventDefault();
        }
    }

    searchList = (value) => {
        pageIndex = 0;
        this.setState({
            isLoading: true,
            formDataList: [],
            searchKey: value,
            dataSource: this.state.dataSource.cloneWithRows([])
        }, () => setTimeout(this.getLinkedDataForm(this.state.definitionId, this.state.fieldId, this.state.searchKey), 10));
    }

    async getLinkedDataForm(definitionId, fieldId, searchKey) {
        const res = await _getLinkedDataForm(this.sid, pageIndex, pageSize, definitionId, fieldId, searchKey);
        if (res.code === 0) {
            for (var i = 0; i < res.data.list.length; i++) {
                res.data.list[i].checked = false;
                var has = false;
                for (var j = 0; j < this.state.selectedFormData.length; j++) {
                    if (this.state.selectedFormData[j].formDataId == res.data.list[i].formDataId) {
                        has = true;
                        break;
                    }
                }
                if (has) {
                    res.data.list[i].checked = true;
                }
            }
            this.state.formFieldList = [];
            for (var key in res.data.formFieldList) {
                this.state.formFieldList.push(res.data.formFieldList[key]);
            }
            this.state.formDataList = this.state.formDataList.concat(res.data.list);
            this.setState({
                formDataList: this.state.formDataList,
                dataSource: this.state.dataSource.cloneWithRows(this.state.formDataList),
                isLoading: false,
                formFieldList: this.state.formFieldList,
            });
        } else {
            Toast.info(res.msg, 1);
        }
    }

    goBack() {
        this.setState({ modalVisible: false, });
    }

    handleOk = e => {
        if (!this.state.selectedFormData || this.state.selectedFormData.length == 0) {
            Toast.info("请选择审批单", 1);
            return;
        }
        var selectedData = [].concat(this.state.selectedFormData);
        this.props.callback(this.props.extra, selectedData);
        this.setState({ modalVisible: false, });
    };

    onFormDataSelect(checked, rowData) {
        var index = -1;
        for (var i = 0; i < this.state.selectedFormData.length; i++) {
            if (this.state.selectedFormData[i].formDataId == rowData.formDataId) {
                index = i;
                break;
            }
        }
        if (checked) {
            if (index == -1) {
                this.state.selectedFormData.push(rowData);
            }
        } else {
            if (index >= 0) {
                this.state.selectedFormData.splice(index, 1);
            }
        }
        this.setState({ selectedFormData: this.state.selectedFormData });
    }

    selectALL(checked) {
        this.state.formDataList.map(item => {
            item.checked = checked;
        });

        this.state.formDataList = JSON.parse(JSON.stringify(this.state.formDataList));

        if (checked) {
            this.setState({ selectedFormData: this.state.formDataList, dataSource: this.state.dataSource.cloneWithRows(this.state.formDataList) });
        } else {
            this.setState({ selectedFormData: [], dataSource: this.state.dataSource.cloneWithRows(this.state.formDataList) });
        }
    }

    showModal = () => {
        this.pageIndex = 0;
        var selectedList = [];
        if (this.props.selectedData) {
            selectedList = [...this.props.selectedData];
        }

        var definitionId = this.props.extra.definitionId;
        var fieldId = this.props.extra.fieldId;
        this.setState({
            selectedFormData: selectedList,
            dataSource: this.state.dataSource.cloneWithRows([]),
            formDataList: [], modalVisible: true,
            definitionId: definitionId,
            searchKey: "",
            fieldId: fieldId
        }, () => { this.getLinkedDataForm(definitionId, fieldId, this.state.searchKey) });
        if (this.props.extra && this.props.extra.maxLength && this.props.extra.maxLength > 0) {
            this.maxLength = this.props.extra.maxLength;
        } else {
            this.maxLength = 30;
        }
    }

    renderRow = (rowData, rowID) => {
        return <li key={rowID} style={{ paddingLeft: 20, paddingTop: 13, display: 'block', height: 'auto' }}>
            <Checkbox style={{ width: '100%' }} disabled={rowData.disabled}
                defaultChecked={rowData.checked}
                onChange={(e) => this.onFormDataSelect(e.target.checked, rowData)}>
                {rowData.instanceTitle}
            </Checkbox>
        </li>
    }

    render() {
        return <Modal wrapProps={{ onTouchStart: this.onWrapTouchStart }} visible={this.state.modalVisible} animationType="slide-up">
            <div className={styles.crm_select}>
                <div className={styles.selectCrmContent}>
                    <div className={styles.clientList} style={{ height: this.state.height }}>
                        <div className={styles.navBoxFixed}>
                            <div className={styles.searchWrap}>
                                <div className={styles.searchBar}>
                                    {
                                        // <div className={styles.searchTitle}>
                                        //            					<span className={styles.ellipsis} onClick={()=>this.setState({isShowSearchPop:!this.state.isShowSearchPop})}>全部</span>
                                        //            					<span className={styles.searchSan}></span>
                                        //            					{
                                        //            						this.state.isShowSearchPop?<span>
                                        //              					<span className={styles.searchPopsan}></span>
                                        //              					<ul className={styles.searchPop}>
                                        //              					{
                                        //              						this.state.formFieldList.map((item, index) => {
                                        //              						 return  <li key={index} style={{minHeight:30}}>{item.fieldTitle}</li>
                                        //              						})
                                        //              					}
                                        //              					</ul>
                                        //            						</span>:""
                                        //            					}
                                        //            				</div>
                                    }
                                    <SearchBar className={styles.searchInputWrap} placeholder="搜索" maxLength={20} value={this.state.searchKey}
                                        onChange={(value) => this.setState({ searchKey: value })}
                                        onCancel={() => { this.setState({ searchKey: "" }); this.searchList(""); }}
                                        onClear={() => { this.setState({ searchKey: "" }); this.searchList(""); }}
                                        onSubmit={(value) => this.searchList(value)} />
                                </div>
                            </div>
                            {
                                // <div className={[`${styles.allSelectBox}`,`${styles.checkbox}`].join(' ')}>
                                //             				<Checkbox style={{display: 'block', width:'100%'}} onClick={(e)=>this.selectALL(e.target.checked)}>全选</Checkbox>
                                //             			</div>
                            }
                            <ListView
                                ref={el => this.lv = el}
                                dataSource={this.state.dataSource}
                                renderFooter={() => (<div style={{ padding: 0, textAlign: 'center' }}>{this.state.isLoading ? '加载中...' : '共' + this.state.formDataList.length + '个审批单'}</div>)}
                                renderRow={(rowData, rowID) => this.renderRow(rowData, rowID)}
                                style={{ height: this.state.height - 166, overflow: 'auto' }}
                                pageSize={pageSize}
                                removeClippedSubviews={false}
                                onEndReached={this.onEndReached}
                                onEndReachedThreshold={1000} />
                        </div>
                    </div>
                    <div className={styles.userOrDeptSelectFooter}>
                        <div className={styles.buttonGroup}>
                            <Button style={{ flex: 1, height: 44, marginRight: 15 }} onClick={() => this.goBack()}>取消</Button>
                            <Button style={{ flex: 1, height: 44 }} type="primary" onClick={() => this.handleOk()}>{this.state.selectedFormData.length > 0 ? <span>选择{this.state.selectedFormData.length}条</span> : <span>确认</span>}</Button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    }

}

export default SelectFormData;